<script setup lang="ts">
import noProductImage from '@/assets/images/no-product-image.png';
import BaseImage from "@/core/components/base/BaseImage.vue";

const props = withDefaults(defineProps<{ product: {photoPath?: string; name: string}; size?: number }>(), {size: 48});
/**
 * Get the product image uri from a LaboratoryProduct.
 *
 * @returns string | undefined
 */
const getLaboratoryProductImage = () => {
    const path = props.product?.photoPath;
    const basePath = import.meta.env.PROD ? import.meta.env.VITE_API_URL : 'https://api.apodispharma.com';

    if ((!!path && path?.length !== 0)) {
        return `${basePath}/images/${path}`;
    }

    return noProductImage;
};
</script>

<template>
  <BaseImage
    rendered
    :class="`w-${size} h-${size} rounded-lg`"
    :text="product.name"
    :path="getLaboratoryProductImage()"
  />
</template>

<style scoped>

</style>
